import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=44cc6974&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=js&"
export * from "./AdminLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=44cc6974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc6974",
  null
  
)

export default component.exports